import Portal from '@arcgis/core/portal/Portal';
import OAuthInfo from '@arcgis/core/identity/OAuthInfo';
import esriId from '@arcgis/core/identity/IdentityManager';
import PortalGroup from '@arcgis/core/portal/PortalGroup';
import store from '../store/store';
import { setIsLoggedinUserAdmin } from '../store/slices/appSlice';
import { ADMIN_GROUP_ID } from '../config/arcgis.config';

class AuthController {
  portal?: any;

  checkSignIn = async (oauthInfo: OAuthInfo) => {
    this.portal = new Portal({
      authMode: 'immediate',
    });

    if (oauthInfo.portalUrl !== 'https://www.arcgis.com') {
      this.portal.url = oauthInfo.portalUrl;
    }

    await this.portal.load();

    if (!this.portal.credential) {
      return;
    }
    return this.portal;
  };

  manageUserAuthentication = async () => {
    const oauthInfo = new OAuthInfo({
      appId: 'IDoUcWyXCLkmHw3n',
      popup: false,
      portalUrl: 'https://wfid.maps.arcgis.com/',
    });

    esriId.registerOAuthInfos([oauthInfo]);
    try {
      await esriId.checkSignInStatus(`${oauthInfo.portalUrl}/sharing`);
      return this.checkSignIn(oauthInfo);
    } catch {
      try {
        await esriId.getCredential(`${oauthInfo.portalUrl}/sharing`);
        return this.checkSignIn(oauthInfo);
      } catch (error) {
        console.error(error);
      }
    }
  };

  getGroupInfoByItemID = async (loggedInUser: string) => {
    try {
      const portal = new Portal();
      portal.load().then(async () => {
        // Fetch the group details
        const group = new PortalGroup({
          id: ADMIN_GROUP_ID,
          portal: portal,
        });

        try {
          const response = await group.fetchMembers();
          const admins = response?.admins || [];
          const users = response?.users || [];
          if (admins?.includes(loggedInUser) || users?.includes(loggedInUser)) {
            store.dispatch(setIsLoggedinUserAdmin(true));
          }
        } catch (_) {
          // user is not in the admin group, user should only see verification page
          store.dispatch(setIsLoggedinUserAdmin(false));
        }
      });
    } catch (error) {
      console.error('Error fetching group info:', error);
    }
  };
}

const authController = new AuthController();

export default authController;
